import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AdminNpsSurveyService } from '../services/admin/admin-nps-survey.service';
import { NpsSurveySettings } from '../common/model/dto/survey/nps-survey-settings';

const NPS_SURVEY_SETTINGS_QUERY_KEY = ['admin-nps-survey-settings'];

export function useAdminNpsSurveySettings() {
  const qc = useQueryClient();

  const settings = useQuery({
    queryKey: NPS_SURVEY_SETTINGS_QUERY_KEY,
    queryFn: () => AdminNpsSurveyService.getNpsSurveySettings(),
  });

  const updateSettings = useMutation({
    mutationFn: (surveySettings: NpsSurveySettings) =>
      AdminNpsSurveyService.updateNpsSurveySettings(surveySettings),
    onSuccess: (surveySettings) =>
      qc.setQueryData(NPS_SURVEY_SETTINGS_QUERY_KEY, surveySettings),
  });

  return { settings, updateSettings };
}
